import { Base } from "./base";
import { getAccessToken, getApp } from "../utils/browserStorage";

export class ProblemType extends Base {
  /**
   * @description List problem type API function
   * @returns {Promise<Response>}
   */
  list(parentId = "", fullAccess = "") {
    const app = getApp() || "CGM";
    const str = parentId
      ? `?app=${app}&parentId=${parentId}&fullAccess=${fullAccess}`
      : `?app=${app}&fullAccess=${fullAccess}`;
    const url = this._getFullURL(`/cmms/problem-type${str}`);
    return this._secureFetch(url);
  }
  listByToken(token) {
    const app = getApp() || "CGM";
    const url = this._getFullURL(`/cmms/problem-type-by-token?token=` + token);
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  /**
   * @description Create problem type API function
   * @param {object} payload
   * @param fileInput
   * @returns {Promise<Response>}
   */
  create(payload) {
    const url = this._getFullURL("/cmms/problem-type");
    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }

  /**
   * @description Get problem type API function
   * @param {string} id
   * @returns {Promise<Response>}
   */
  get(id) {
    const url = this._getFullURL(`/cmms/problem-type/${id}`);
    return fetch(url, this._generateRequestBody({}));
  }

  /**
   * @description Update problem type API function
   * @param {string} id
   * @param {object} payload
   * @returns {Promise<Response>}
   */
  update = (id, payload) => {
    const url = this._getFullURL(`/cmms/problem-type/${id}`);

    return fetch(url, this._generateRequestBody({ payload, method: "PUT" }));
  };

  /**
   * @description Delete location API function
   * @param {string} id
   * @returns {Promise<Response>}
   */
  delete = (id) => {
    const url = this._getFullURL(`/cmms/problem-type/${id}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: null,
        method: "DELETE",
      })
    );
  };
}
